import React from 'react';
import NavBar from './Components/NavBar/NavBar';
import Main from './Components/Main/Main';
import Footer from './Components/Footer/Footer';
 
function App(props) {
  return (
    <React.Fragment>

      <NavBar />

      <Main />

      <Footer />
      
    </React.Fragment>
  );
}

export default App;
